import { UiSpreadSheetCell } from '@aksia/infrastructure';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getByRowCol',
  standalone: true,
})
export class GetByRowColPipe<T> implements PipeTransform {
  transform(
    data: Array<UiSpreadSheetCell<T>>,
    col: number,
    row: number,
  ): UiSpreadSheetCell<T> | undefined {
    return data?.find(
      (item) => item.columnIndex === col && item.rowIndex === row,
    );
  }
}
